export default "__VITE_ASSET__BHriaVQG__"